<template>
  <div
    class="pt-navbar-height flex min-h-screen w-full flex-col justify-between"
  >
    <!-- <NuxtErrorBoundary>
      <NavigationMain />
    </NuxtErrorBoundary> -->

    <NuxtErrorBoundary>
      <main class="relative flex flex-1 flex-col items-center justify-center">
        <h1 class="mx-auto text-4xl font-bold">
          {{ error.statusCode }}
        </h1>
        <h2 class="mx-auto my-4 max-w-xl">
          {{
            props.error.statusCode === 404 ? $t('error.404') : $t('error.500')
          }}
        </h2>

        <IconLogo class="absolute -z-10 size-full"></IconLogo>

        <!-- LINK -->
        <button
          type="button"
          :aria-label="$t('error.backToHomepage')"
          class="text-white rounded-full bg-Blue-Primary px-7 py-2.5 font-medium"
          @click="handleError('/')"
        >
          <I18nT tag="span" keypath="error.backToHomepage" />
        </button>

        
      </main>
    </NuxtErrorBoundary>
  </div>
</template>

<script setup lang="ts">
if (import.meta.client) {
  document.body.classList.add(useIsTouchDevice() ? 'is-touch' : 'no-touch')
}

const props = defineProps<{
  error: any
}>()

const handleError = (uri: string) => {
  clearError({
    redirect: uri,
  })
}

const gqlErrorData = computed(() => {
  if (!props.error.data) return null

  return JSON.parse(props.error.data)
})

const errorMessage = computed(() => {
  if (!gqlErrorData.value) return props.error.statusMessage

  return `${props.error.statusMessage} - ${gqlErrorData.value.message}`
})
</script>
